import { useEffect, useRef } from "react";
import * as THREE from "three";
import * as Yup from "yup";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import classroomModel from "../../assets/img/models/classroom.glb";
import ananya from "../../assets/img/models/char_ananya.glb";
import arjun from "../../assets/img/models/char_arjun.glb";
import aryan from "../../assets/img/models/char_aryan.glb";
import dev from "../../assets/img/models/char_dev.glb";
import diya from "../../assets/img/models/char_diya.glb";
import ishita from "../../assets/img/models/char_ishita.glb";
import meera from "../../assets/img/models/char_meera.glb";
import vihaan from "../../assets/img/models/char_vihaan.glb";
import { useState } from "react";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import ReplayIcon from "@mui/icons-material/Replay";
import {
  Box,
  Button,
  Grid2,
  Slider,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import { createStudentBones } from "../../shared/utils/studentBones";
import { setupStudentBones } from "../../shared/utils/boneHelpers";
import { useAllThreejsView, useAllThreejsViewFilter } from "../../assets/nodeApi/getApi/getAdminApi";
import { ImagePathNode, Grid_Gap, Input_Width_LG } from "../../shared/constants";
import { NormalContainerWithHeader } from "../../shared/components/student/NormalComponent";
import { Field, Form, Formik } from "formik";
import CustomDivider from "../../shared/utils/CustomDivider";
import { useLmsDropdownOptions } from "./option/LsmOption";
import { AutoCompleteFieldThreejs } from "../../shared/components/formfields/AutoCompleteThreejs";



export default function ThreejsView() {
  const mountRef = useRef(null);
  const deg = (d) => THREE.MathUtils.degToRad(d);
  const sceneRef = useRef(null);
  const studentTurnIndexRef = useRef(0);
  const modelsLoadedRef = useRef(false);
  const skipCurrentRef = useRef(false);
  const [playState, setPlayState] = useState("start");
  const [setModelsReady] = useState(false);
  const [sceneKey, setSceneKey] = useState(0);
  const lessonIndexRef = useRef(0);
  const timeoutRefs = useRef([]);
  const isPausedRef = useRef(false);
  const isRunningRef = useRef(false);
  const currentAudioRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [voiceGender, setVoiceGender] = useState("male");



  const addTimeout = (fn, delay) => {
    const id = setTimeout(() => {
      if (!isPausedRef.current) {
        fn();
      }
    }, delay);

    timeoutRefs.current.push(id);
  };


  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedTopicId, setSelectedTopicId] = useState(null);
  const { ThreejsViewOptions } = useLmsDropdownOptions({ ThreejsFilter: { status: true } })
  const {
    data: topicFilterData,
  } = useAllThreejsViewFilter(selectedCourseId, {
    enabled: !!selectedCourseId,
  });

  const topicOptions =
    topicFilterData?.data?.[0]?.topics?.map((item, index) => ({
      id: item.id,
      label: item.name,
      value: item.id,
      sr_no: index + 1,
      ...item,
    })) ?? [];

  const { data: voicethrejsview, isLoading, refetch } =
    useAllThreejsView(selectedTopicId, {
      enabled: !!selectedTopicId,
    });
  const lessonDialogRef = useRef([]);

  useEffect(() => {
    const checkOrientation = () => {
      const mobile = window.innerWidth < 768;
      const portrait = window.innerHeight > window.innerWidth;

      setIsMobile(mobile);
      setIsPortrait(portrait);
    };

    checkOrientation();

    window.addEventListener("resize", checkOrientation);
    window.addEventListener("orientationchange", checkOrientation);

    return () => {
      window.removeEventListener("resize", checkOrientation);
      window.removeEventListener("orientationchange", checkOrientation);
    };
  }, []);



  useEffect(() => {
    //   if (voicethrejsview?.data) {
    //     const dialog = voicethrejsview.data.flatMap((item) => [
    //       {
    //         type: "teacher",
    //         text: item?.question_text || "",
    //         // audio: item?.question_audio_url
    //         //   ? `${ImagePathNode}${item.question_audio_url}`
    //         //   : null,
    //         audio:
    //           voiceGender === "male"
    //             ? item?.male_question_audio_url
    //               ? `${ImagePathNode}${item.male_question_audio_url}`
    //               : null
    //             : item?.female_question_audio_url
    //               ? `${ImagePathNode}${item.female_question_audio_url}`
    //               : null,
    //       },
    //       {
    //         type: "student",
    //         text: item?.answers?.[0]?.answer_text || "",
    //         // audio: item?.answers?.[0]?.answer_audio_url
    //         //   ? `${ImagePathNode}${item.answers[0].answer_audio_url}`
    //         //   : null,

    //         audio: item?.answers?.[0]?.female_answer_audio_url
    // ? `${ImagePathNode}${item.answers[0].female_answer_audio_url}`
    // : null,
    //       },
    //     ]);

    //     lessonDialogRef.current = dialog;

    //     // RESET LOGIC
    //     lessonIndexRef.current = 0;
    //     studentTurnIndexRef.current = 0;

    //     // CLEAR BLACKBOARD
    //     if (blackboardRef.current.mesh && sceneRef.current) {
    //       sceneRef.current.remove(blackboardRef.current.mesh);
    //       blackboardRef.current.mesh = null;
    //     }

    //     // CLEAR POPUPS
    //     allStudents.forEach((ref) => {
    //       const r = ref.current;
    //       if (r?.popup && sceneRef.current) {
    //         sceneRef.current.remove(r.popup);
    //         r.popup = null;
    //       }
    //     });

    //     setPlayState("start");
    //   }
    if (voicethrejsview?.data) {

      const dialog = voicethrejsview.data.flatMap((item) => [

        // QUESTION
        {
          type: "teacher",

          text: item?.question_text || "",

          audio:
            voiceGender === "male"
              ? item?.male_question_audio_url
                ? `${ImagePathNode}${item.male_question_audio_url}`
                : null
              : item?.female_question_audio_url
                ? `${ImagePathNode}${item.female_question_audio_url}`
                : null,
        },

        // ANSWER
        {
          type: "student",

          text: item?.answers?.[0]?.answer_text || "",

          audio:
            item?.answers?.[0]?.female_answer_audio_url
              ? `${ImagePathNode}${item.answers[0].female_answer_audio_url}`
              : null,
        },

      ]);

      lessonDialogRef.current = dialog;

      lessonIndexRef.current = 0;
      studentTurnIndexRef.current = 0;

      if (blackboardRef.current.mesh && sceneRef.current) {
        sceneRef.current.remove(blackboardRef.current.mesh);
        blackboardRef.current.mesh = null;
      }

      allStudents.forEach((ref) => {
        const r = ref.current;

        if (r?.popup && sceneRef.current) {
          sceneRef.current.remove(r.popup);
          r.popup = null;
        }
      });

      setPlayState("start");
    }
    // }, [voicethrejsview]);
  }, [voicethrejsview, voiceGender]);




  const ananyaBonesRef = useRef(createStudentBones());
  const arjunBonesRef = useRef(createStudentBones(true, true));
  const aryanBonesRef = useRef(createStudentBones());
  const devBonesRef = useRef(createStudentBones());
  const diyaBonesRef = useRef(createStudentBones());
  const ishitaBonesRef = useRef(createStudentBones());
  const meeraBonesRef = useRef(createStudentBones());
  const vihaanBonesRef = useRef(createStudentBones(true));

  const students = [
    { model: ananya, ref: ananyaBonesRef, name: "Ananya", pos: [-1, -0.2, -1.6] }, //fixed
    { model: arjun, ref: arjunBonesRef, name: "Arjun", pos: [-1, -0.2, 1] },   //fixed
    { model: aryan, ref: aryanBonesRef, name: "Aryan", pos: [-2.2, -0.2, -0.2] }, //fixed
    { model: dev, ref: devBonesRef, name: "Dev", pos: [0.5, -0.2, -0.2] },//fixed
    { model: diya, ref: diyaBonesRef, name: "Diya", pos: [2.1, -0.2, -1.5] }, //fixed
    { model: ishita, ref: ishitaBonesRef, name: "Ishita", pos: [0.9, -0.2, -1.5] }, //fixed
    { model: meera, ref: meeraBonesRef, name: "Meera", pos: [0.9, -0.2, -1.5] },//fixed
    { model: vihaan, ref: vihaanBonesRef, name: "Vihaan", pos: [1, -0.2, -0.1] },  //fixed

  ];



  const handleToggle = async () => {
    if (!sceneRef.current) return;
    // ---------------- START ----------------
    if (playState === "start") {
      setPlayState("loading");

      // reset state
      lessonIndexRef.current = 0;
      studentTurnIndexRef.current = 0;
      isPausedRef.current = false;
      isRunningRef.current = false;
      isStudentTalkingRef.current = false;

      timeoutRefs.current.forEach((t) => clearTimeout(t));
      timeoutRefs.current = [];

      await refetch();

      setTimeout(() => {
        if (modelsLoadedRef.current && lessonDialogRef.current.length > 0) {
          isPausedRef.current = false;
          isRunningRef.current = true;

          setPlayState("pause");
          startLesson();
        }
      }, 100);

      return;
    }

    // ---------------- PAUSE ----------------
    if (playState === "pause") {
      isPausedRef.current = true;
      isRunningRef.current = false;
      setPlayState("resume");
      return;
    }
    // ---------------- RESUME ----------------
    if (playState === "resume") {
      isPausedRef.current = false;
      isRunningRef.current = true;
      setPlayState("pause");
      // nextTick();
    }

  };
  useEffect(() => {
    if (!mountRef.current) return;
    const isMobile = window.innerWidth < 768;

    const initThreeJS = () => {
      const width = mountRef.current.clientWidth;
      const height = mountRef.current.clientHeight;
      if (width === 0 || height === 0) {
        requestAnimationFrame(initThreeJS);
        return;
      }
      const scene = new THREE.Scene();
      sceneRef.current = scene;
      const camera = new THREE.PerspectiveCamera(
        isMobile ? 75 : 60,
        width / height,
        0.1,
        100
      );


      const renderer = new THREE.WebGLRenderer({ antialias: true });
      renderer.setSize(width, height);

      mountRef.current.appendChild(renderer.domElement);

      const light = new THREE.HemisphereLight(0xffffff, 0x444444);
      scene.add(light);

      const loader = new GLTFLoader();

      // classroom
      loader.load(classroomModel, (gltf) => {
        scene.add(gltf.scene);
      });

      let loadedCount = 0;

      students.forEach(({ model, ref, name, pos }) => {
        loader.load(model, (gltf) => {
          const student = gltf.scene;

          student.position.set(...pos);
          scene.add(student);
          setupStudentBones(student, ref.current, name);
          ref.current.model = student;
          loadedCount++;
          if (loadedCount === students.length) {
            modelsLoadedRef.current = true;
            setModelsReady(true);
          }
        });
      });

      function animate() {
        renderer.setAnimationLoop(() => renderer.render(scene, camera));
      }
      animate();
      const resizeObserver = new ResizeObserver(() => {
        if (!mountRef.current) return;
        const w = mountRef.current.clientWidth;
        const h = mountRef.current.clientHeight;
        camera.aspect = w / h;
        const isTabletOrMobile =
          w < 800 || window.innerHeight > window.innerWidth;
        if (isTabletOrMobile) {
          camera.position.set(0, 1.4, 8);
          camera.fov = 50; // your requirement
        } else {
          camera.position.set(0, 1.4, 8);
          camera.fov = 60;
        }
        camera.updateProjectionMatrix();
        renderer.setSize(w, h);
      });
      resizeObserver.observe(mountRef.current);

      return () => {
        resizeObserver.disconnect();
        renderer.dispose();
        if (mountRef.current) {
          mountRef.current.removeChild(renderer.domElement);
        }
      };

    };

    initThreeJS();
    return () => {
      // 1. Clear all active timeouts
      timeoutRefs.current.forEach((t) => clearTimeout(t));
      timeoutRefs.current = [];

      // 2. Stop any currently playing audio
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
        currentAudioRef.current.src = ""; // Force the browser to drop the resource
        currentAudioRef.current = null;
      }

      // 3. Stop the lesson loop
      isRunningRef.current = false;

      // ... existing Three.js cleanup ...
      if (sceneRef.current) {
        while (sceneRef.current.children.length > 0) {
          sceneRef.current.remove(sceneRef.current.children[0]);
        }
      }
      if (mountRef.current) {
        mountRef.current.innerHTML = "";
      }
    };


  }, [sceneKey]);

  const animateRotation = (bone, axis, target, duration = 800) => {
    if (!bone) return;

    const start = bone.rotation[axis];
    const startTime = performance.now();

    function animate(time) {
      const t = Math.min((time - startTime) / duration, 1);
      bone.rotation[axis] = start + (target - start) * t;

      if (t < 1) requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  };

  const animateBoneX = (bone, target, duration = 800) => {
    animateRotation(bone, "x", target, duration);
  };

  const animatePositionY = (object, targetY, duration = 800) => {
    const startY = object.position.y;
    const startTime = performance.now();

    function animate(time) {
      const t = Math.min((time - startTime) / duration, 1);
      object.position.y = startY + (targetY - startY) * t;

      if (t < 1) requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  };


  const standLegs = (ref) => {
    animateBoneX(ref.leftThigh, ref.standLeftThigh);
    animateBoneX(ref.rightThigh, ref.standRightThigh);
    animateBoneX(ref.leftShin, ref.standLeftShin);
    animateBoneX(ref.rightShin, ref.standRightShin);

    ref.isSitting = false;
  };

  const sitLegs = (ref) => {
    animateBoneX(ref.leftThigh, ref.sitThigh, 1000);
    animateBoneX(ref.rightThigh, ref.sitThigh, 1000);
    animateBoneX(ref.leftShin, ref.sitShin, 1000);
    animateBoneX(ref.rightShin, ref.sitShin, 1000);
  };
  const raiseHand = (studentRef, student, audioUrl) => {
    // Stand FIRST
    addTimeout(() => {
      if (student) anchorToFloor(student, 0.2);
      standLegs(studentRef);
    }, 500);

    // THEN raise hand


    addTimeout(() => {
      // Check if the user navigated away before playing
      if (!isRunningRef.current || isPausedRef.current) return;

      if (audioUrl) {
        if (currentAudioRef.current) {
          currentAudioRef.current.pause();
          currentAudioRef.current.currentTime = 0;
        }

        // const audio = new Audio(audioUrl);
        // currentAudioRef.current = audio;
        // audio.play().catch(() => { });

        const audio = new Audio(audioUrl);

        audio.playbackRate = playbackSpeed;

        currentAudioRef.current = audio;

        audio.play().catch(() => { });

        // Optional: Cleanup ref when audio naturally ends
        audio.onended = () => { currentAudioRef.current = null; };
      }
      // ... arm animations ...
      animateRotation(studentRef.leftArm, "x", deg(150));
      animateRotation(studentRef.leftForearm, "x", deg(-20));
    }, 1200);

    // Sit back
    addTimeout(() => {
      sitLegs(studentRef);

      if (student) {
        const box = new THREE.Box3().setFromObject(student);
        const targetY = student.position.y + (0 - box.min.y);

        animatePositionY(student, targetY + 0.1, 800);
      }
    }, 5000);

    addTimeout(() => {
      isStudentTalkingRef.current = false;
    }, 6000);
  };





  const lowerHand = (studentRef) => {
    const { leftArm, leftForearm } = studentRef;

    animateRotation(leftArm, "x", deg(15), 1000);
    animateRotation(leftForearm, "x", deg(30), 1000);


    if (studentRef.popup) {
      if (studentRef.popup.parent) {
        studentRef.popup.parent.remove(studentRef.popup);
      }
      studentRef.popup = null;
    }
  };
  const blackboardRef = useRef({
    mesh: null
  });

  const isStudentTalkingRef = useRef(false);


  const startLesson = () => {
    const scene = sceneRef.current;

    if (!scene) {
      return;
    }

    // Directly check the Ref instead of the State for the most up-to-date value
    if (!modelsLoadedRef.current || lessonDialogRef.current.length === 0) {
      return;
    }

    let index = lessonIndexRef.current;
    const next = () => {
      if (isPausedRef.current) return;

      // Skip logic
      if (skipCurrentRef.current) {
        skipCurrentRef.current = false;
        index++;
        lessonIndexRef.current = index;
        return next();
      }

      if (index >= lessonDialogRef.current.length) {
        isRunningRef.current = false;
        isPausedRef.current = true;

        // clear blackboard
        if (blackboardRef.current.mesh && sceneRef.current) {
          sceneRef.current.remove(blackboardRef.current.mesh);
          blackboardRef.current.mesh = null;
        }

        // clear popups
        allStudents.forEach((ref) => {
          const r = ref.current;
          if (r?.popup && sceneRef.current) {
            sceneRef.current.remove(r.popup);
            r.popup = null;
          }
        });

        setPlayState("start");
        return;
      }

      // DEFINE dialog HERE (FIX)
      const dialog = lessonDialogRef.current[index];

      if (!dialog) return;




      // ---------------- TEACHER ----------------
      // if (dialog.type === "teacher") {
      //   TextShowingInBlackBoard(scene, dialog.text, dialog.image);
      //   const displayTime = dialog.duration || 4000;
      //   addTimeout(() => {
      //     if (isPausedRef.current) return;
      //     index++;
      //     lessonIndexRef.current = index;
      //     next();
      //   }, displayTime);
      // }

      if (dialog.type === "teacher") {

        TextShowingInBlackBoard(scene, dialog.text, dialog.image);

        // PLAY TEACHER AUDIO
        if (dialog.audio) {

          // stop previous audio
          if (currentAudioRef.current) {
            currentAudioRef.current.pause();
            currentAudioRef.current.currentTime = 0;
          }

          const audio = new Audio(dialog.audio);

          audio.playbackRate = playbackSpeed;

          currentAudioRef.current = audio;

          audio.play().catch((err) => {
            console.log("Teacher audio error:", err);
          });

          audio.onended = () => {
            currentAudioRef.current = null;
          };
        }

        const chunks = splitTextIntoChunks(dialog.text, 120);

        const displayTimePerChunk = 5000;

        const totalTime = chunks.length * displayTimePerChunk;

        addTimeout(() => {
          if (isPausedRef.current) return;

          index++;
          lessonIndexRef.current = index;

          next();
        }, totalTime);
      }

      // ---------------- STUDENT ----------------
      else if (dialog.type === "student") {
        if (isStudentTalkingRef.current) return;
        isStudentTalkingRef.current = true;
        let studentRef = null;
        // find next READY student
        for (let i = 0; i < allStudents.length; i++) {
          const idx = (studentTurnIndexRef.current + i) % allStudents.length;
          const ref = allStudents[idx].current;
          if (ref && ref.model) {
            studentRef = ref;
            studentTurnIndexRef.current = (idx + 1) % allStudents.length;
            break;
          }
        }

        if (!studentRef) {
          isStudentTalkingRef.current = false;
          index++;
          lessonIndexRef.current = index;
          return next();
        }
        // studentTurnIndexRef.current =
        //   (studentTurnIndexRef.current + 1) % allStudents.length;

        if (!studentRef) {
          isStudentTalkingRef.current = false;

          index++;
          lessonIndexRef.current = index;

          return next();
        }

        raiseHand(studentRef, studentRef.model, dialog.audio);
        addTimeout(() => {
          if (isPausedRef.current) return;
          create3DPopup(scene, dialog.text, studentRef);
          addTimeout(() => {
            lowerHand(studentRef);
            isStudentTalkingRef.current = false;
            index++;
            lessonIndexRef.current = index;
            next();
          }, 4000);
        }, 1000);
      }
    };

    next();
  };

  const create3DPopup = (scene, text, studentRef) => {
    if (studentRef.popup) {
      studentRef.popup.parent?.remove(studentRef.popup);
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const fontSize = 40;
    const lineHeight = 40;

    ctx.font = `bold ${fontSize}px Arial`;

    const words = text.split(" ");
    let line = "";
    let lines = [];

    const maxWidthLimit = 500;

    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + " ";
      const testWidth = ctx.measureText(testLine).width;

      if (testWidth > maxWidthLimit && n > 0) {
        lines.push(line.trim());
        line = words[n] + " ";
      } else {
        line = testLine;
      }
    }

    lines.push(line.trim());

    let maxLineWidth = 0;
    lines.forEach((l) => {
      const w = ctx.measureText(l).width;
      if (w > maxLineWidth) maxLineWidth = w;
    });

    const padding = 20;
    const width = maxLineWidth + padding * 2;
    const height = lines.length * lineHeight + padding * 2;

    canvas.width = width;
    canvas.height = height;



    /* -------- BACKGROUND -------- */
    const radius = 20;

    ctx.fillStyle = "rgba(30, 30, 60, 0.85)";
    ctx.beginPath();
    ctx.moveTo(radius, 0);
    ctx.lineTo(width - radius, 0);
    ctx.quadraticCurveTo(width, 0, width, radius);
    ctx.lineTo(width, height - radius);
    ctx.quadraticCurveTo(width, height, width - radius, height);
    ctx.lineTo(radius, height);
    ctx.quadraticCurveTo(0, height, 0, height - radius);
    ctx.lineTo(0, radius);
    ctx.quadraticCurveTo(0, 0, radius, 0);
    ctx.closePath();
    ctx.fill();
    ctx.strokeStyle = "rgba(255,255,255,0.25)";
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.font = `bold ${fontSize}px Arial`;
    ctx.fillStyle = "#FFFF99";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    const textBlockHeight = lines.length * lineHeight;
    const startY = (height - textBlockHeight) / 2;
    lines.forEach((l, i) => {
      ctx.fillText(l, width / 2, startY + i * lineHeight + lineHeight / 2);
    });
    const texture = new THREE.CanvasTexture(canvas);
    const material = new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
    });

    const mesh = new THREE.Mesh(
      new THREE.PlaneGeometry(width / 300, height / 300),
      material
    );

    const headBone =
      studentRef.leftHandEnd ||
      studentRef.rightHandEnd ||
      studentRef.spine02;
    if (headBone) {
      const pos = new THREE.Vector3();
      headBone.getWorldPosition(pos);
      mesh.position.set(pos.x, pos.y + 1, pos.z);
      mesh.lookAt(pos.x, pos.y, pos.z + 2);
    }
    scene.add(mesh);
    studentRef.popup = mesh;
  };
  const anchorToFloor = (model, floorY = 0) => {
    const box = new THREE.Box3().setFromObject(model);
    const delta = floorY - box.min.y;
    model.position.y += delta;
  };

  const allStudents = [
    arjunBonesRef,
    vihaanBonesRef,
    ananyaBonesRef,
    aryanBonesRef,
    diyaBonesRef,
    devBonesRef,
    ishitaBonesRef,
    meeraBonesRef
  ];

  // const TextShowingInBlackBoard = (scene, text, imageUrl) => {

  //   const { mesh } = blackboardRef.current;

  //   if (mesh) {
  //     mesh.parent && mesh.parent.remove(mesh);
  //     blackboardRef.current.mesh = null;
  //   }

  //   const canvas = document.createElement("canvas");
  //   const ctx = canvas.getContext("2d");
  //   if (!ctx) return;

  //   canvas.width = 1700;
  //   canvas.height = 500;

  //   const width = canvas.width;
  //   const height = canvas.height;

  //   ctx.fillStyle = "#ffffff";
  //   ctx.font = "bold 70px Arial";
  //   ctx.textAlign = "center";
  //   ctx.textBaseline = "middle";

  //   const maxWidth = 1410;
  //   const lineHeight = 75;

  //   const words = text.split(" ");
  //   let line = "";
  //   let lines = [];

  //   for (let n = 0; n < words.length; n++) {
  //     const testLine = line + words[n] + " ";
  //     const metrics = ctx.measureText(testLine);

  //     if (metrics.width > maxWidth && n > 0) {
  //       lines.push(line);
  //       line = words[n] + " ";
  //     } else {
  //       line = testLine;
  //     }
  //   }

  //   lines.push(line);

  //   const startY = height / 2 - ((lines.length - 1) * lineHeight) / 2;

  //   lines.forEach((l, i) => {
  //     ctx.fillText(l, width / 2, startY + i * lineHeight);
  //   });

  //   const createMesh = () => {
  //     const texture = new THREE.CanvasTexture(canvas);
  //     texture.needsUpdate = true;

  //     const material = new THREE.MeshBasicMaterial({
  //       map: texture,
  //       transparent: true
  //     });

  //     const geometry = new THREE.PlaneGeometry(4, 1.5);
  //     const mesh = new THREE.Mesh(geometry, material);

  //     mesh.position.set(-0.1, 2.2, 0);

  //     scene.add(mesh);
  //     blackboardRef.current.mesh = mesh;
  //   };

  //   if (imageUrl) {
  //     const images = Array.isArray(imageUrl) ? imageUrl : [imageUrl];
  //     let loaded = 0;

  //     images.forEach((src, index) => {
  //       const img = new Image();
  //       img.src = src;

  //       img.onload = () => {
  //         ctx.drawImage(img, 350 + index * 300, 259, 250, 180);

  //         loaded++;
  //         if (loaded === images.length) {
  //           createMesh();
  //         }
  //       };
  //     });
  //   } else {
  //     createMesh();
  //   }
  // };





  const TextShowingInBlackBoard = (scene, text, imageUrl) => {
    const oldMesh = blackboardRef.current.mesh;
    if (oldMesh) {
      oldMesh.parent?.remove(oldMesh);
      blackboardRef.current.mesh = null;
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = 1600;
    canvas.height = 400;

    const texture = new THREE.CanvasTexture(canvas);

    const drawText = (textPart) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 70px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const maxWidth = 1410;
      const lineHeight = 75;

      const words = textPart.split(" ");
      let line = "";
      let lines = [];

      for (let i = 0; i < words.length; i++) {
        const testLine = line + words[i] + " ";
        const width = ctx.measureText(testLine).width;

        if (width > maxWidth && i > 0) {
          lines.push(line);
          line = words[i] + " ";
        } else {
          line = testLine;
        }
      }
      lines.push(line);

      const startY =
        canvas.height / 2 - ((lines.length - 1) * lineHeight) / 2;

      lines.forEach((l, i) => {
        ctx.fillText(l, canvas.width / 2, startY + i * lineHeight);
      });

      texture.needsUpdate = true;
    };

    const material = new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
    });

    const geometry = new THREE.PlaneGeometry(4, 1.5);
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(-0.1, 2.2, 0);

    scene.add(mesh);
    blackboardRef.current.mesh = mesh;
    const chunks = splitTextIntoChunks(text, 70);

    let index = 0;

    const renderChunk = () => {
      if (index >= chunks.length) return;

      drawText(chunks[index]);
      index++;

      setTimeout(renderChunk, 5000);
    };

    renderChunk();
  };







  const splitTextIntoChunks = (text, maxLength) => {
    const words = text.split(" ");
    const chunks = [];
    let currentChunk = "";

    words.forEach((word) => {
      if ((currentChunk + word).length > maxLength) {
        chunks.push(currentChunk.trim());
        currentChunk = word + " ";
      } else {
        currentChunk += word + " ";
      }
    });

    if (currentChunk) {
      chunks.push(currentChunk.trim());
    }

    return chunks;
  };


  useEffect(() => {
    if (!selectedTopicId) return;
    const scene = sceneRef.current;
    isRunningRef.current = false;
    isPausedRef.current = true;
    lessonIndexRef.current = 0;
    studentTurnIndexRef.current = 0;
    lessonDialogRef.current = [];
    timeoutRefs.current.forEach((t) => clearTimeout(t));
    timeoutRefs.current = [];
    if (blackboardRef.current.mesh && scene) {
      scene.remove(blackboardRef.current.mesh);
      blackboardRef.current.mesh = null;
    }

    allStudents.forEach((ref) => {
      const r = ref.current;
      if (r?.popup && scene) {
        scene.remove(r.popup);
        r.popup = null;
      }
    });

    setPlayState("start");
    setSceneKey(prev => prev + 1);
  }, [selectedTopicId]);


  const validationSchema = Yup.object({
    course: Yup.mixed().required("Please select course"),
    topic: Yup.mixed().required("Please select topic"),
  });


  return (
    <NormalContainerWithHeader headerText={"Add ThreeJs View"}>
      <Formik
        // initialValues={{
        //   name: ""
        // }}
        initialValues={{
          course: null,
          topic: null,
        }}
        validationSchema={validationSchema}
        onSubmit={() => {
          handleToggle();
        }}
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Grid2 container spacing={Grid_Gap}>
              <Grid2 size={6}>
                <Field
                  name="course"
                  component={AutoCompleteFieldThreejs}
                  options={ThreejsViewOptions.options}
                  label="Course"
                  onValueChange={(value) => {
                    setSelectedCourseId(value?.id || value?.value);
                    setSelectedTopicId(null);
                  }}
                />
              </Grid2>

              <Grid2 size={6}>
                <Field
                  name="topic"
                  component={AutoCompleteFieldThreejs}
                  options={topicOptions}
                  label="Topics"
                  onValueChange={(value) => {
                    setSelectedTopicId(value?.id || value?.value);
                  }}
                />
              </Grid2>
            </Grid2>
            <CustomDivider />
            <Box sx={{ mb: 2 }}>

              <Typography variant="h5">
                Select Question Voice
              </Typography>

              <FormControl>
                <RadioGroup
                  row
                  value={voiceGender}
                  onChange={(e) => {
                    setVoiceGender(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="male"
                    label="Male"
                    sx={{
                      "& .MuiFormControlLabel-label": { 
                        color: "blue.main",
                      },
                    }}
                    control={
                      <Radio
                        sx={{
                             color: "blue.main",
                          "&.Mui-checked": {
                              color: "blue.main",
                          },
                        }}
                      />
                    }
                  />

                  <FormControlLabel
                    value="female"
                    label="Female"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                         color: "blue.main",
                      },
                    }}
                    control={
                      <Radio
                        sx={{
                           color: "blue.main",
                          "&.Mui-checked": {
                               color: "blue.main",
                          },
                        }}
                      />
                    }
                  />
                </RadioGroup>
              </FormControl>

            </Box>



            <Box >
              <Typography gutterBottom sx={{mb:2}}>
                Playback Speed: {playbackSpeed}x
              </Typography>

              {/* <Slider
                value={playbackSpeed}
                min={0.5}
                max={3}
                step={0.25}
                marks
                valueLabelDisplay="auto"
                onChange={(e, value) => {
                  setPlaybackSpeed(value);

                  if (currentAudioRef.current) {
                    currentAudioRef.current.playbackRate = value;
                  }
                }}

                sx={{
                   color: "blue.main",

                  "& .MuiSlider-track": {
                    backgroundColor:  "blue.main",
                  },

                  "& .MuiSlider-thumb": {
                    backgroundColor: "blue.main",
                  },

                  "& .MuiSlider-rail": {
                    backgroundColor: "#D5E0FF", // remaining part
                    opacity: 1,
                  },
                }}
              /> */}
<Slider
  value={playbackSpeed}
  min={0.5}
  max={3}
  step={0.25}
  marks
  valueLabelDisplay="on"
  valueLabelFormat={(value) => `${value}x`}
  onChange={(e, value) => {
    setPlaybackSpeed(value);

    if (currentAudioRef.current) {
      currentAudioRef.current.playbackRate = value;
    }
  }}
  sx={{
    color: "blue.main",

    "& .MuiSlider-track": {
      backgroundColor:"blue.main",
    },

    "& .MuiSlider-thumb": {
      backgroundColor:"blue.main",
    },

    "& .MuiSlider-rail": {
      backgroundColor: "#D5E0FF",
      opacity: 1,
    },

    "& .MuiSlider-mark": {
      backgroundColor: "blue.main",
    },

    "& .MuiSlider-markLabel": {
      color: "blue.main",
    },

    "& .MuiSlider-valueLabel": {
      background: "transparent",
      color: "blue.main",
      boxShadow: "none",
      top:5
    },

    "& .MuiSlider-valueLabel *": {
      background: "transparent",
      color:"blue.main",
    },

    "& .MuiSlider-valueLabel:before": {
      display: "none",
    },
  }}
/>
            </Box>

            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={isLoading}
              startIcon={
                playState === "start" ? <PlayArrowIcon /> :
                  playState === "pause" ? <PauseIcon /> :
                    <ReplayIcon />
              }
            >
              {isLoading
                ? "Loading..."
                : playState === "start"
                  ? "Start"
                  : playState === "pause"
                    ? "Pause"
                    : "Resume"}
            </Button>

          </Form>
        )}
      </Formik>
      <CustomDivider />


      {isMobile && isPortrait && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "black",
            color: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
          }}
        >
          <Typography variant="h5" sx={{ color: "primary.main" }}>
            Rotate your device
          </Typography>

          <Typography variant="h6" sx={{ color: "primary.main" }}>
            Please switch to landscape mode
          </Typography>
        </Box>
      )}
      <Box
        ref={mountRef}
        sx={{
          display: isMobile && isPortrait ? "none" : "block",
          width: "100%",
          height: "100vh",
          borderRadius: 2,
          overflow: "hidden",
          maxWidth: "100%",
          boxShadow: 3,
        }}
      />
    </NormalContainerWithHeader>
  );

}




